"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function GeralInformations() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "informacoes-gerais"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, /*#__PURE__*/_react["default"].createElement("strong", null, "1. INFORMA\xC7\xD5ES GERAIS")), /*#__PURE__*/_react["default"].createElement("p", null, "Ao usar esses servi\xE7os, o ", /*#__PURE__*/_react["default"].createElement("strong", null, " USU\xC1RIO "), "compartilhar\xE1 algumas informa\xE7\xF5es conosco. A presente Pol\xEDtica de Privacidade explica: quais informa\xE7\xF5es ser\xE3o coletadas, onde as elas ser\xE3o armazenadas, como ser\xE3o utilizadas, quem ter\xE1 acesso a essas informa\xE7\xF5es, quais s\xE3o as medidas utilizadas para oferecer controle e seguran\xE7a \xE0s informa\xE7\xF5es coletadas e como o", /*#__PURE__*/_react["default"].createElement("strong", null, " USU\xC1RIO "), "possui controle e acesso para atualizar ou apagar seus dados."));
}
var _default = GeralInformations;
exports["default"] = _default;